import { UserLogoutRequestEvent } from '@ori-events/user-logout-request';

import { clearAllSessionStorageKeys } from '../utils/clearAllSessionStorageKeys';

function showLogoutModal() {
  clearAllSessionStorageKeys();
  const userLogoutRequestEvent = new CustomEvent(UserLogoutRequestEvent);
  window.dispatchEvent(userLogoutRequestEvent);
}

/** Hook that exposes function that, when called, shows user logout modal */
export const useLogout = () => showLogoutModal;
